import { State } from "./State";
export class Board {
    /**
     * Retorna el número de celdas no vacías del cartón
     */
    get numCells() {
        return this.cells.reduce((a, c) => {
            if (!c) {
                return a;
            }
            return a + 1;
        }, 0);
    }
    constructor(eventsChannelFactory, id, gameId, playerId, hasFigure, hasBingo, cells) {
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.gameId = gameId;
        this.playerId = playerId;
        this.cells = cells;
        this.checkedCount = new State(0);
        this.hasFigure = new State(hasFigure);
        this.hasBingo = new State(hasBingo);
        this.updateCheckedCount();
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`board.${this.id}`);
    }
    checkCell(number) {
        for (const cell of this.cells) {
            if ((cell === null || cell === void 0 ? void 0 : cell.number) === number) {
                cell.check();
                this.updateCheckedCount();
                return;
            }
        }
    }
    getCell(number) {
        for (const cell of this.cells) {
            if ((cell === null || cell === void 0 ? void 0 : cell.number) === number) {
                return cell;
            }
        }
        return null;
    }
    updateCheckedCount() {
        this.checkedCount.set(this.cells.reduce((a, cell) => {
            if (!(cell === null || cell === void 0 ? void 0 : cell.isChecked)) {
                return a;
            }
            return a + 1;
        }, 0));
    }
}
